import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PagingData } from '@app/models/paging-data';
import { SnapshotData } from '@app/models/snapshot-data';
import { EcommerceService } from '@app/services/ecommerce.service';
import { NzTableModule, NzTableQueryParams } from 'ng-zorro-antd/table';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { PropertiesPipe } from './propertiesPipe'; 

@Component({
  standalone: true,
  selector: 'split-table-modal',

  imports: [PropertiesPipe, CommonModule, NzButtonModule, NzCollapseModule, NzGridModule, NzImageModule, NzTableModule, NzTabsModule, NzToolTipModule],
  templateUrl: './split-table.component.html',
  styleUrls: ['./split-table.component.less'],
})
export class SplitTableComponent implements OnInit {

  columns: any[] = [];
  summaryColumns: any[] = [];
  pageSize = 10;
  pageIndex = 1;
  total = 0;
  resultData: any;
  summaryResultData: any;
  itemId = ''
  version = ''
  category = ''
  $refreshInterval?: any;
  tabIndex = 0
  totalCount = 0
  isFinished = true

  constructor(private ecommerceService: EcommerceService, private router: ActivatedRoute,private cdr: ChangeDetectorRef,) { }

  scrollX: string | null = null;
  ngOnInit(): void {
    this.scrollX = 'calc(100vm - 100px)/2';
    this.columns = [{ key: 'prodId', title: 'Product Id', align: 'left', width: '80px' }
      , { key: 'splitId', title: 'Split Id', align: 'left', width: '30px' }
      , { key: 'prodName', title: 'Product Name', align: 'left', width: '200px' }
      , { key: 'category', title: 'Category', align: 'left', width: '50px' }
      , { key: 'packSize', title: 'Pack Size', align: 'left', width: '50px' }
      ,{ key: 'inferPackSize', title: 'Est.PackSize', align: 'left', width: '50px' }
      , { key: 'unit', title: 'Unit', align: 'left', width: '50px' }
      , { key: 'inferUnit', title: 'Est.Unit', align: 'left', width: '50px' }
      , { key: 'price', title: 'Price', align: 'left', width: '50px' }
      , { key: 'volume', title: 'Volume', align: 'left', width: '50px' }
    ]
    this.summaryColumns = [
      { key: 'splitId', title: 'Split Id', align: 'left', width: '30px' }
      , { key: 'prodName', title: 'Product Name', align: 'left', width: '200px' }
      , { key: 'packSize', title: 'Pack Size', align: 'left', width: '50px' }
      , { key: 'unit', title: 'Unit', align: 'left', width: '50px' }
      , { key: 'volume', title: 'Volume', align: 'left', width: '50px' }
      , { key: 'price', title: 'Price', align: 'left', width: '50px' }
      , { key: 'prodId', title: 'Product Id', align: 'left', width: '80px' }
    ]
    this.router.queryParams.subscribe(queryParams => {
      this.itemId = queryParams['itemId']
      this.version = queryParams['version']
      this.category = queryParams['category']
      this.fetchApiItemSearch(this.pageIndex, this.pageSize);
      this.fetchApiItemSummary(this.pageIndex, this.pageSize);
      this.queryItemsCount()
    });
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;
    this.fetchApiItemSearch(pageIndex, pageSize);
  }

  isLoading$ = new BehaviorSubject<boolean>(false);
  snapshotItem: Array<SnapshotData> = [];
  getPayload(): any {
    const params = {
      itemId: this.itemId,
      version: this.version,
      category:this.category
    };
    return params;
  }
  resetIconPaddingTop() {
    const hight = (this.resultData.length / 2) * 60;
    const forwardIcon = document.getElementsByClassName('api-forward-body')[0] as HTMLElement;
    forwardIcon.style.paddingTop = `${hight}px`;
  }
  jobId: any = null;
  async fetchApiItemSearch(pageNum: number, pageSize: number) {
    try {
      this.isLoading$.next(true);
      let data = {} as PagingData<any>;
      data = await lastValueFrom(this.ecommerceService.queryResults(this.getPayload()));
      
      if (!data) return;
      this.resultData = data;
      this.isLoading$.next(false);
      if (this.totalCount === this.resultData.length && this.totalCount !== 0) {
        return true
      } else {
        this.isFinished = false
        this.refreshResult()
        return false
      }
    } catch (e) {
      this.isLoading$.next(false);
      return false
    }

  }
  async fetchApiItemSummary(pageNum: number, pageSize: number) {
    try {
      this.isLoading$.next(true);
      let data = {} as PagingData<any>;
      data = await lastValueFrom(this.ecommerceService.querySummaryResults(this.getPayload()));

      if (!data) return;
      this.summaryResultData = data;
      this.isLoading$.next(false);
    } catch (e) {
      this.isLoading$.next(false);
    }

  }
  async queryItemsCount() {
    try {
      const data = await lastValueFrom(this.ecommerceService.queryBatchItemsCount(this.getPayload()));
      if (!data) return;
      this.totalCount = data;
    } catch (e) {
    }

  }
  refresh() {
    this.fetchApiItemSearch(this.pageIndex, this.pageSize);
  }
  refreshResult() {
    this.isLoading$.next(true);
    if (!this.$refreshInterval) {
      this.$refreshInterval = setInterval(async () => {
        if (await this.fetchApiItemSearch(this.pageIndex, this.pageSize)) {
          clearInterval(this.$refreshInterval);
          this.refreshSummary()
          this.isLoading$.next(false);
          this.isFinished = true
          this.cdr.detectChanges()
        }
      }, 1000 * 8);
    }
  }
  stopRefreshTask() {
    if (this.$refreshInterval) {
      clearInterval(this.$refreshInterval);
      this.$refreshInterval = null;
      this.isLoading$.next(false);
    }
  }
  ngOnDestroy(): void {
    this.stopRefreshTask();
  }
  refreshSummary() {
    this.fetchApiItemSummary(this.pageIndex, this.pageSize);
  }
}
